import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SuccessCardComponent} from "./success-card.component";
import {CardModule} from "../../../modules/core/component/card/card.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        CardModule,
    ],
    declarations: [
        SuccessCardComponent,
    ],
    exports: [
        SuccessCardComponent,
    ],
})
export class SuccessCardModule {}